import { type Theme } from '@mui/material';

export const adyenOverrides = (theme: Omit<Theme, 'components'>) => `
:root {
	--adyen-sdk-text-body-font-family: Tenon, sans-serif;
	--adyen-sdk-text-caption-font-family: Tenon, sans-serif;
	--adyen-sdk-text-title-font-family: Tenon, sans-serif;
	--adyen-sdk-text-title-m-font-family: Tenon, sans-serif;
	--adyen-sdk-text-title-l-font-family: Tenon, sans-serif;
	--adyen-sdk-text-body-font-size: ${theme.typography.body1.fontSize}px;
	--adyen-sdk-text-caption-font-size: ${theme.typography.body2.fontSize}px;
	--adyen-sdk-color-background-inverse-primary: ${theme.palette.cvi.primary[30]};
	--adyen-sdk-color-background-inverse-primary-hover: ${theme.palette.cvi.primary[20]};
	--adyen-sdk-color-background-inverse-primary-active: ${theme.palette.cvi.primary[40]};
	--adyen-sdk-color-outline-tertiary: ${theme.palette.cvi.neutrals[50]};
	--adyen-sdk-color-outline-critical: ${theme.palette.cvi.red[40]};
	--adyen-sdk-color-label-critical: ${theme.palette.cvi.red[40]};
	--adyen-sdk-color-background-highlight-weak: ${theme.palette.cvi.blue[10]};
	--adyen-sdk-border-radius-m: ${theme.borderRadius.medium}px;
}
`;
